import React from 'react';
import cx from 'classnames';
import { withRouter } from '../util/withRouter';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Grid from './form/Grid';
import { Draggable } from './DragDrop';
import DeleteIcon from './icon/DeleteIcon';
import AudioSampler from './AudioSampler';
import Checkbox from './form/Checkbox';
import OptionalTextField from './form/OptionalTextField';

class SongDragger extends React.Component {
    state = {};

    render() {
        const { classes, form, listType, disabled, provided: droppableProvided } = this.props;
        const o = listType;
        return (
            <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
                {!(form.getField(o.list) && form.getField(o.list).length) ? (
                    <Grid pc={1}>No songs selected.</Grid>
                ) : (
                    form
                        .getField(o.list)
                        // rely on backend for initial sort :)
                        // .sort((a, b) => (a.SongSort < b.SongSort ? -1 : 1))
                        .map((e, i, a) => (
                            <Draggable
                                key={e.ID || `${e.Artist + e.Name + i}`}
                                id={e.ID || `${e.Artist + e.Name + i}`}
                                group={o.type}
                                index={i}
                            >
                                {(provided, snapshot) => (
                                    <div
                                        className={cx(classes.listItem, snapshot.isDragging && classes.dragging)}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                    >
                                        <div className={classes.mainInfo}>
                                            <span className={classes.countR}>{i + 1}</span>
                                            {!disabled && (
                                                <span
                                                    style={{ float: 'right' }}
                                                    {...provided.dragHandleProps}
                                                    title="Reorder"
                                                    tabIndex="0"
                                                >
                                                    <IconButton
                                                        style={{ pointerEvents: 'none' }}
                                                        tabIndex="-1"
                                                        size="large"
                                                    >
                                                        <Icon>drag_indicator</Icon>
                                                    </IconButton>
                                                </span>
                                            )}

                                            <AudioSampler title={e.Name} artist={e.Artist} filename={e.Pathname} />

                                            <span>
                                                <IconButton
                                                    disabled={disabled}
                                                    title="Remove"
                                                    onClick={() => {
                                                        const arr = form.getField(o.list);
                                                        arr.splice(i, 1);
                                                        form.setField({
                                                            [o.list]: arr
                                                        });
                                                    }}
                                                    size="large"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </span>
                                        </div>
                                        {o.list === 'ReflectionMusicSongs' && (
                                            <div className={classes.extraStuff}>
                                                <Checkbox
                                                    disabled={disabled}
                                                    name={'ReflectionMusicSongs[i].IncludeInLifeStory'}
                                                    label={'Song to be played during life story'}
                                                    checked={
                                                        form.getField('ReflectionMusicSongs')[i].IncludeInLifeStory ||
                                                        false
                                                    }
                                                    onChange={e => {
                                                        const ReflectionMusicSongs = form.getField(
                                                            'ReflectionMusicSongs'
                                                        );
                                                        ReflectionMusicSongs[i].IncludeInLifeStory =
                                                            e.target.checked || false;
                                                        form.setField({
                                                            ReflectionMusicSongs
                                                        });
                                                    }}
                                                />
                                                <Checkbox
                                                    disabled={disabled}
                                                    name={'ReflectionMusicSongs[i].ForFlowerPlacement'}
                                                    label={'Song to be played during flowers'}
                                                    checked={
                                                        form.getField('ReflectionMusicSongs')[i].ForFlowerPlacement
                                                    }
                                                    onChange={e => {
                                                        const ReflectionMusicSongs = form.getField(
                                                            'ReflectionMusicSongs'
                                                        );
                                                        ReflectionMusicSongs[i].ForFlowerPlacement =
                                                            e.target.checked || false;
                                                        form.setField({
                                                            ReflectionMusicSongs
                                                        });
                                                    }}
                                                />
                                                <div>
                                                    <OptionalTextField
                                                        buttonlabel={'+ Add Song Notes'}
                                                        name={'ReflectionMusicSongs[i].OtherText'}
                                                        label={'Song Notes'}
                                                        value={form.getField('ReflectionMusicSongs')[i].OtherText || ''}
                                                        multiline
                                                        rows={2}
                                                        onChange={e => {
                                                            const ReflectionMusicSongs = form.getField(
                                                                'ReflectionMusicSongs'
                                                            );
                                                            ReflectionMusicSongs[i].OtherText = e.target.value || null;
                                                            form.setField({
                                                                ReflectionMusicSongs
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Draggable>
                        ))
                )}
                {this.props.provided.placeholder}
            </div>
        );
    }
}

const styles = ({ palette, funeralHome, typography, sizes }) => ({
    listItem: {
        width: 'calc(100% + 12px)',
        padding: '0 0 0 6px',
        margin: '0 -6px',
        borderRadius: 5, // backgroundColor: palette.contentBackground[funeralHome],
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.035)'
        },
        '& > span': {
            display: 'inline-block',
            fontSize: '0.875rem',
            verticalAlign: 'middle'
        },
        '& > p': {
            margin: '0.65rem 0'
        }
    },
    mainInfo: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center'
    },
    extraStuff: {
        padding: '0.5rem 6px 1rem 42px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 6,
        columnGap: 6,
        '& > div': {
            marginBottom: 0
        }
    },
    dragging: {
        backgroundColor: '#ccc' //palette.contentBackground[funeralHome]
    },
    countR: {
        borderRadius: 24,
        background: palette.contentForeground[funeralHome],
        color: 'white',
        minWidth: 24,
        minHeight: 24,
        display: 'inline-flex',
        justifyContent: 'center'
    }
});

export default withRouter(withStyles(styles)(SongDragger));
